<template>
  <div class="flash-list" v-if="finalDatas.items&&finalDatas.items.length>0&&canShow" :style="goodsStyle">
    <div class="title" v-if="finalDatas.goodstitle||!finalDatas.hideMore">
      <div class="tl" :style="titFontSize">{{finalDatas.goodstitle}}</div>
      <div class="more" @click="goShopFlashSale" v-if="!finalDatas.hideMore">更多<i class="iconfont icongengduo1"></i></div>
    </div>
    <div class="goods-list-box" scroll-x="true" :class="finalDatas.layout">
      <div class="goods-list-container">
        <div class="box-container" v-for="(item,i) in finalDatas.items" :key="i" @click="goFlashGoods(item)" v-if="item.sta!='2'">
          <div class="box">
            <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
              <img class="img" v-if="isSquarePic=='T'" :src="item.logo+'?imageView2/1/w/500/h/500/format/webp&x-oss-process=image/resize,m_fill,w_500,h_500'" />
              <img class="img" v-else :src="item.logo+'?imageView2/1/w/336/h/224/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224'" />
              <!-- <img class="bg" src="https://xcx.ihotel.cn/mall/images/goods-bg.png" /> -->
            </div>
            <div class="goods-content">
              <div class="goods-name">{{item.name}}</div>
              <div class="price-box" :style="priceColor">
                <div class="price" v-if="!(item.price<=0&&item.credit<=0)">
                  <span class="cur-price" v-if="item.price>0">
                    <i>￥</i>
                    <b :style="priceSize">{{item.price}}</b>
                  </span>
                  <div class="credit" v-if="item.credit>0">
                    <span>
                      <em v-if="item.price>0">+</em>
                      {{item.credit}}
                    </span>
                    <b>{{creditName}}</b>
                  </div>
                  <span class="proposedPrice" v-if="item.proposedPrice>0">
                    ￥{{item.proposedPrice}}
                  </span>
                </div>
                <div class="price" v-else>
                  <span class="cur-price free">
                    <b>免费</b>
                  </span>
                </div>

              </div>
            </div>
            <div class="time" v-if="item.sta == 0">
              <div class="lable">距开始：</div>
              <div class="val">{{item.beforeTime}}</div>
            </div>
            <div class="time" v-if="item.sta == 1">
              <div class="lable">剩余时间:</div>
              <div class="val">{{item.duringTime}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
// 抢购
import price from '@/components/price';
import {
  setStorage,
  getStorage
} from "@/utils/wxuser";
import api from "@/utils/api";
var config = {};

export default {
  props: {
    datas: Object,
    showHeader: {
      type: Boolean,
      default: () => true
    },
    templateId: String,
  },
  data() {
    return {
      timer: null,
      creditName: getStorage('creditName') || '积分',
      currentTime: '',
      code: "",
      finalDatas: {},
      isSquarePic: getStorage('isSquarePic') || 'F',
      canShow: false
    };
  },
  components: {
    price
  },
  computed: {
    priceSize() {
      if (this.finalDatas.priceSize) {
        return `font-size:${this.finalDatas.priceSize};`
      } else {
        return ""
      }

    },
    limitFlashTitle() {
      var limitFlashTitle = [];
      this.finalDatas.items.forEach((item, i) => {
        var sTime = item.startTime || item.dayStartTime;
        var eTime = item.endTime || item.dayEndTime;

        if (item.timeSlotList && item.timeSlotList.length > 0) {
          if (item.timeSlotList[0].endTime) {
            var endTimeSlot = item.timeSlotList[0].endTime
            var startTimeSlot = item.timeSlotList[0].startTime
            sTime = moment(sTime).format('YYYY-MM-DD') + moment(startTimeSlot).format(' HH:mm:ss')
            eTime = moment(eTime).format('YYYY-MM-DD') + moment(endTimeSlot).format(' HH:mm:ss')
          }
        }

        var startTime = moment(sTime).format('x');
        var endTime = moment(eTime).format('x');
        if (startTime > this.currentTime) {
          var time = startTime - this.currentTime;
          var day = Math.floor(time / 1000 / 60 / 60 / 24);
          var hour = Math.floor(time / 1000 / 60 / 60) - day * 24;
          var minutes =
            Math.floor(time / 1000 / 60) - day * 24 * 60 - hour * 60;
          var seconds =
            Math.floor(time / 1000) -
            day * 24 * 60 * 60 -
            hour * 60 * 60 -
            minutes * 60;
          limitFlashTitle.push([
            '距开始',
            day +
            '天' +
            this.cutDate(hour) +
            ':' +
            this.cutDate(minutes) +
            ':' +
            this.cutDate(seconds)
          ]);
        } else if (startTime < this.currentTime && endTime > this.currentTime) {
          var time = endTime - this.currentTime;
          var day = Math.floor(time / 1000 / 60 / 60 / 24);
          var hour = Math.floor(time / 1000 / 60 / 60) - day * 24;
          var minutes =
            Math.floor(time / 1000 / 60) - day * 24 * 60 - hour * 60;
          var seconds =
            Math.floor(time / 1000) -
            day * 24 * 60 * 60 -
            hour * 60 * 60 -
            minutes * 60;
          limitFlashTitle.push([
            '距结束',
            day +
            '天' +
            this.cutDate(hour) +
            ':' +
            this.cutDate(minutes) +
            ':' +
            this.cutDate(seconds)
          ]);
        } else {
          limitFlashTitle.push(['已结束', '0天 0:00:00']);
        }
      });

      return limitFlashTitle;
    },
    goodsStyle() {
      var style = ''

      if (this.finalDatas.backgroundColor) {
        style += `background:${this.finalDatas.backgroundColor};`
      }
      return style
    },
    priceColor() {
      return `color:${this.finalDatas.priceColor}`
    },
    titFontSize() {

      var titFontSize = `font-size:${this.finalDatas.titFontSize};`
      if (this.finalDatas.titColor) {
        titFontSize += `color:${this.finalDatas.titColor};`
      }

      return titFontSize
    },
  },

  methods: {
    countDown() {
      this.timer = setInterval(() => {
        this.canShow = true
        this.finalDatas.items.forEach((n, i) => {
          if (n.startSecends > 0) {
            n.startSecends -= 1;
          }
          if (n.endSecends > 0) {
            n.endSecends -= 1;
          }
          if (n.startSecends > 0 && n.endSecends > 0) {

            var beforeTime = this.getCountDownTime(n.startSecends);
            this.$set(n, 'sta', 0)
            this.$set(n, 'beforeTime', beforeTime)
          } else if (n.startSecends == 0 && n.endSecends > 0) {

            var duringTime = this.getCountDownTime(n.endSecends);
            this.$set(n, 'sta', 1)
            this.$set(n, 'duringTime', duringTime)
          } else {
            this.$set(n, 'sta', 2)

          }

        })
      }, 1000);
    },
    getCountDownTime(leftTime) {
      var d = Math.floor(leftTime / 60 / 60 / 24);
      var h = Math.floor(leftTime / 60 / 60 % 24);
      var m = Math.floor(leftTime / 60 % 60);
      var s = Math.floor(leftTime % 60);
      if (d > 0) {
        d = d + "天"
      } else {
        d = ''
      }
      if (h < 10) {
        h = "0" + h
      }
      if (m < 10) {
        m = "0" + m
      }
      if (s < 10) {
        s = "0" + s
      }
      return `${d}${h}:${m}:${s}`
    },
    cutDate(val) {
      if (val <= '9') {
        val = '0' + val;
        return val;
      } else {
        return val;
      }
    },
    update(val) {
      this.code = val
      this.initeData()
    },
    initeData() {
      this.finalDatas = JSON.parse(JSON.stringify(this.datas))
      console.log(this.finalDatas)
      api.secondRush({
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        channel: config.channel,
        appid: config.appid,
        shopChannel: "flash",
      })
        .then((res) => {
          if (res.result == 1) {
            var rushGoods = res.retVal;

            rushGoods.forEach(utem => {
              this.finalDatas.items.forEach(goods => {
                if (utem.id == goods.id && utem.relationId == goods.relationId) {
                  goods.name = utem.goodsName;
                  goods.logo = utem.flashLogo;
                  goods.name = utem.goodsName;
                  goods.price = utem.price;
                  goods.credit = utem.credit;
                  goods.proposedPrice = utem.proposedPrice;
                  goods.logo = utem.flashLogo;
                  goods.timeSlotList = utem.timeSlotList;
                  goods.dayStartTime = utem.dayStartTime;
                  goods.dayEndTime = utem.dayEndTime;
                  goods.startSecends = utem.startSecends;
                  goods.endSecends = utem.endSecends;


                }
              })

            })


          }
          this.countDown()

        });

    },
    goFlashGoods(item) {
      if (!item.url) {
        this.$router.push({
          path: '/goodsDetail',
          query: {
            flashTimeSlotRelitionId: item.relationId,
            id: item.id,
            productType: 'flash'
          }
        });
      } else {
        window.location.href = `${window.location.origin}${item.url}`;
      }
    },
    goShopFlashSale() {
      if (this.templateId) {
        this.$router.push({
          path: '/shopFlashSale'
        });
      } else {
        this.$router.push({
          path: '/shopFlashSale',
          query: {
            aggregatePageId: this.$route.query.id
          }
        });
      }

    },
    addCurrentTime() {
      this.currentTime = new Date().getTime();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentTime += 1000;
      }, 1000);
    }
  },
  created() {
    config = getStorage("config");
  },
  mounted() {
    this.initeData()
    this.addCurrentTime();
  }
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.flash-list {
  padding-top: 0.4rem;

  .title {
    display: flex;
    position: relative;
    height: 1.2rem;
    align-items: center;

    .tl {
      padding-left: 0.533333rem;
      font-size: 18px;
      color: #1d1e2c;
      font-weight: bold;
    }

    .more {
      font-size: 12px;
      color: #666666;
      display: flex;
      position: relative;
      height: 1.2rem;
      align-items: center;
      position: absolute;
      bottom: 0;
      right: 0.533333rem;

      i {
        font-size: 12px;
        color: #666666;
      }
    }

    // .arrow::after {
    //   width: 0.16rem;
    //   height: 0.16rem;
    //   margin-top: -2px;
    // }
  }

  .goods-list-box {
    margin-top: -0.266667rem;
    padding: 0 0.133333rem 0;
    &.bigImg {
      margin-top: 0;
      padding: 0 0.4rem;
      .box-container {
        display: block;
        padding-bottom: 0;
      }
      .box {
        margin: 0;
        width: 100%;
        .img-box {
          height: 6.1rem;
          &.img-box-square {
          height: 9.2rem;
        }
        }
        .goods-content {
          .goods-name {
            font-size: 16px;
            line-height: 0.586667rem;
            height: 1.173333rem;
          }
        }

        .time {
          right: 0.133333rem;
          width: auto;
          bottom: 0.4rem;
          position: absolute;
          .val {
            padding: 0 20px;
          }
        }
      }
    }
    .box-container {
      padding-bottom: 0.74rem;
      display: inline-block;
      vertical-align: top;
    }

    .box {
      position: relative;
      width: 4.586667rem;
      padding: 0 0 0.266667rem 0;
      background: #fff;

      border-radius: 0.213333rem;
      margin: 0.133333rem;
      box-sizing: border-box;

      .img-box {
        width: 100%;
        overflow: hidden;
        height: 3.05rem;
        position: relative;
        box-sizing: border-box;

        &.img-box-square {
          height: 4.586667rem;
        }

        .img {
          width: 100%;
          height: 100%;
          border: 2px solid #fff;
          border-radius: 0.213333rem;
        }

        .bg {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }

        .label {
          position: absolute;
          top: 0.053333rem;
          left: 0.053333rem;
          color: #fff;
          height: 0.64rem;
          font-size: 12px;
          color: #ffffff;
          padding: 0 0.266667rem;
          line-height: 0.64rem;
          text-align: center;
          z-index: 2;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
            background: @color-theme;
            opacity: 0.6;
            border-radius: 0.213333rem 0.213333rem 0.213333rem 0px;
          }
        }
      }

      .goods-content {
        padding: 0 0.133333rem;

        .goods-name {
          font-weight: bold;
          margin-top: 0.133333rem;
          font-size: 14px;
          line-height: 0.533333rem;
          height: 1.066667rem;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space: normal;
        }

        .price-box {
          display: flex;
          justify-content: flex-start;
          color: #e55141;

          .price {
            font-size: 12px;
            display: inline-block;
            align-items: center;

            margin-top: 0.1333rem;
            min-height: 0.6665rem;

            .cur-price {
              display: inline-block;
              // font-family: TimesNewRomanPS-ItalicMT;
              font-family: @price-font-family;
            }

            span {
              display: inline-block;

              i {
                display: inline-block;
                font-family: @price-font-family;
                text-decoration: none;
              }

              b {
                display: inline-block;
                text-decoration: none;
                // font-family: TimesNewRomanPS-BoldItalicMT;
                font-family: @price-font-family;
                font-size: 25px;
              }
            }

            span.proposedPrice {
              line-height: 16px;
              text-decoration: line-through;
              color: #999999;
              font-size: 12px;
              // font-style: italic;
            }

            .credit {
              display: inline-block;
              font-style: normal;

              font-weight: bold;
              font-size: 10px;
              line-height: 16px;

              em,
              b {
                display: inline-block;
              }

              span {
                // font-family: TimesNewRomanPS-BoldItalicMT;
                font-size: 14px;
                display: inline-block;
                font-family: @price-font-family;
              }
            }

            .free {
              b {
                font-size: 18px;
              }
            }
          }
        }
      }
    }

    &.grid {
      .goods-list-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
    }

    &.mult {
      width: 100%;
      white-space: nowrap;
      display: flex;
      padding-bottom: 0.74rem;
      overflow-x: scroll;

      .goods-list-container {
        padding: 0 0.133333rem;

        .box {
          width: 4rem;

          .img-box {
            height: 2.66667rem;

            &.img-box-square {
              height: 4rem;
            }
          }
        }
      }
    }

    &.pic {
      padding: 0 0.133333rem 0.74rem;
      box-sizing: border-box;

      .box {
        width: 100%;
        margin: 0.133333rem 0;
        border-radius: 0;
        border-top-left-radius: 0.533333rem;

        .img-box {
          padding: 0.106667rem;
          height: 4rem;
          &.img-box-square {
              height: 10rem;
            }
          .bg {
            display: none;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 0;
            border-top-left-radius: 0.533333rem;
            border-bottom-right-radius: 0.533333rem;
          }

          .label {
            top: 0.106667rem;
            left: 0.106667rem;
            border-top-left-radius: 0.533333rem;
          }
        }

        .goods-content {
          .goods-name {
            font-size: 18px;
            color: #333333;
            line-height: 0.666667rem;
            height: 0.666667rem;
            -webkit-line-clamp: 1;
          }

          .price {
            justify-content: flex-start;
          }
        }
      }
    }

    &.card {
      padding: 0 0.133333rem 0.74rem;
      box-sizing: border-box;

      .box {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 0.133333rem 0;
        border-radius: 0;
        padding: 0;
        border-top-left-radius: 0.533333rem;

        .img-box {
          width: 4.346667rem;
          height: 3.626667rem;
          &.img-box-square {
              height: 4.346667rem;
            }
          .bg {
            display: none;
          }

          .bg2 {
            display: block;
          }
        }
      }

      .goods-content {
        flex: 1;
        text-align: left;

        .goods-name {
          font-size: 14px;
          color: #333333;
          -webkit-line-clamp: 4;
          line-height: 0.533333rem;
          height: 2.133333rem;
        }

        .price {
          justify-content: flex-start;
        }
      }
    }

    .time {
      background: #ffffff;
      width: 100%;
      height: 0.48rem;
      display: flex;
      align-items: center;
      border: 1px solid #e55141;
      border-radius: 4px;
      position: absolute;
      bottom: -0.74rem;

      &.grey {
        border: 1px solid #999;

        .lable {
          background: #999;
        }

        .val {
          color: #999;
        }
      }

      .lable {
        height: 100%;
        display: flex;
        align-items: center;
        background: #e55141;
        padding: 0 0.186667rem;
        color: #fff;
      }

      .val {
        flex: 1;
        color: #e55141;
        text-align: center;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Flashsale.vue